import { render, staticRenderFns } from "./CrmKpis.vue?vue&type=template&id=01bd633a&scoped=true&"
import script from "./CrmKpis.vue?vue&type=script&lang=js&"
export * from "./CrmKpis.vue?vue&type=script&lang=js&"
import style0 from "./CrmKpis.vue?vue&type=style&index=0&id=01bd633a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bd633a",
  null
  
)

export default component.exports